import {takeLatest, put,select} from 'redux-saga/effects';
import {actions as listActions} from '../slices/VehicleListSlice';
import {actions} from '../slices/VehicleSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';

const getSearchCriteria = state => state.vehicleList.searchCriteria;

function* getVehicle({payload: {page, limit, filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_vehicles')}`, {
            params: {
                page: page ? page - 1 : null,
                size: limit,
                ...filters,
            }
        });
        yield put({type: listActions.get_list_succeed.type, payload: {...response.data}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: listActions.get_list_failed.type, payload: error});
    }
}



function* createVehicle({payload:{params}}) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_vehicles')}`, {
            ...params
        });
        yield put({type: actions.create_vehicle_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.create_vehicle_failed.type, payload: error});
    }
}

function* updateVehicle({payload:{params}}) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_vehicles')}/${params.id}`, {
            ...params
        });
        yield put({type: actions.create_vehicle_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.create_vehicle_failed.type, payload: error});
    }
}

function* deleteVehicle({payload:{id}}) {
    try {
        const response = yield NetworkHandler.delete(`${config.getUrl('bus_vehicles')}/${id}`);
        yield put({type: actions.delete_vehicle_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Xoá thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.delete_vehicle_failed.type, payload: error});
    }
}

function* exportVehicle({payload: {filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_vehicles')}`, {
            params: {
                ...filters,
                export: true,
            }
        });
        NotificationHandler.notifyDownloadBox(response.data);
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: listActions.get_list_failed.type, payload: error});
    }
}


function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getVehicle);
    yield takeLatest(actions.create_vehicle.type,createVehicle);
    yield takeLatest(actions.update_vehicle.type, updateVehicle);
    yield takeLatest(actions.delete_vehicle.type, deleteVehicle);
    yield takeLatest(actions.export_vehicle.type, exportVehicle);
}

export default watchRequestDetail;